/** How the crown health page asks the map for its layers: the screen's archive and what lies under it. */
import { HEALTH_HOTSPOTS, type TiledSource } from '@/map/layers';
import { PMTILES_LAYERS, pmtilesTileUrl } from '@/map/pmtiles';
import { isIndex, type BandRole, type SpectralDisplay, type SpectralView } from '@/map/spectral';
import { DEFAULT_STRETCH } from '../multispectral/config';

/** What lies under the crowns: the RGB orthophoto, or the multispectral one as an index, in false colour or one band. */
export type Backdrop = 'ortho' | SpectralDisplay;
/** The multispectral views worth having under the crowns, in the order offered. */
export const SPECTRAL_BACKDROPS: SpectralDisplay[] = ['ndvi', 'ndre', 'gndvi', 'cir', 'band'];

/** The archive's source layers: the photo inventory's points and polygons and the screen's hotspots. */
export function healthTiles(object: string, maxzoom: number): TiledSource {
  return {
    url: pmtilesTileUrl(object),
    source: `${object}:pmtiles`,
    maxzoom,
    layers: PMTILES_LAYERS.photo,
    areas: HEALTH_HOTSPOTS,
    promoteId: { [PMTILES_LAYERS.photo.points]: 'id', [PMTILES_LAYERS.photo.polygons]: 'id', [HEALTH_HOTSPOTS]: 'hotspot' },
  };
}

/** The spectral view a backdrop asks of the multispectral orthophoto, at the multispectral report's default stretch; `band` is the one a single band shows. */
export function spectralOf(backdrop: Backdrop, band: BandRole = 'nir'): SpectralView | undefined {
  if (backdrop === 'ortho') return undefined;
  if (backdrop === 'band') return { display: 'band', band };
  return isIndex(backdrop) ? { display: backdrop, stretch: DEFAULT_STRETCH[backdrop] } : { display: backdrop };
}
